import React from 'react';
import { useAppSelector } from "../../hooks/redux";
import './shippingAddressSwitcher.scss';
import { ShippingAddressSwitcherProps } from '../interfaces';

const ShippingAddressSwitcher: React.FC<ShippingAddressSwitcherProps> = ({
    onAddressSelect,
}) => {
    const selectedAddressIndex = useAppSelector((state) => state.user.selectedAddress);

    const selectedAddressIdAsNumber = selectedAddressIndex != null ? Number(selectedAddressIndex) : 0;

    const handleAddressChange = (address: number) => {
        onAddressSelect(address, true);
    };

    return (
        <div className="shipping-address-switcher">
            <div className="address-options">
                <button
                    className={`address-button ${selectedAddressIdAsNumber === 0 ? 'active' : ''}`}
                    onClick={() => handleAddressChange(0)}
                >
                    Address 1
                </button>
                <button
                    className={`address-button ${selectedAddressIdAsNumber === 1 ? 'active' : ''}`}
                    onClick={() => handleAddressChange(1)}
                >
                    Address 2
                </button>
            </div>
        </div>
    );
};

export default ShippingAddressSwitcher;
